export const createArray = (length: number) => {
    return new Array(length).fill('');
};
